import { useEffect } from 'react';
import { Alert } from 'reactstrap';

import { getTranslationKey } from 'helpers/texting';
import { Input } from 'modules/ScrShopNew/components/Forms';
import { Button } from 'modules/ScrShopNew/components/Buttons';
import { useTheme } from 'hooks/useTheme';
import { useBodyClassName } from 'hooks/useBodyClassName';
import { applyDesignVariablesToBody } from 'helpers/bodyClassName';
import { usePasswordPage } from './usePasswordPage';

import styled from 'styled-components';

const Form = styled.form<{ background: string }>`
  overflow: hidden;
  height: 100%;
  background: ${({ background }) => background};
`;

const PageTitle = styled.h1<{ $color: string }>`
  color: ${({ $color }) => $color};
`;

const PasswordForm = styled.div`
  label {
    color: var(--primary-color) !important;
  }
`;

export const LegacyPasswordPage: React.FC = () => {
  const [theme] = useTheme();
  const {
    title,
    design,
    password,
    setPassword,
    handlePasswordCheck,
    areCookiesEnabled,
    isWrongPassword,
    lockedUntil,
    lockedUntilText
  } = usePasswordPage();
  useBodyClassName();

  // Apply CSS custom properties to body element for theme styling
  useEffect(() => {
    applyDesignVariablesToBody(design?.variables);
  }, [design]);

  return (
    <Form background={theme.colors.pageBg} onSubmit={handlePasswordCheck}>
      <PasswordForm className="password-form form-group max-w-400 mx-auto p-t-100 p-20">
        <PageTitle $color={theme.colors.fontColor} className="text-center mb-5">
          {title}
        </PageTitle>

        {!areCookiesEnabled ? (
          <p className="text-center">{getTranslationKey('allowCookies')}</p>
        ) : (
          <>
            <Input
              type="password"
              id="pin-password-input"
              className="text-center"
              label={getTranslationKey('shop.forms.galleryPassword')}
              placeholder={getTranslationKey('password')}
              value={password}
              onChange={(event) => setPassword(event.target.value.trimStart())}
              onBlur={(event) => setPassword(event.target.value.trim())}
              spellCheck="false"
              withEye
            />
            <Button type="submit" className="sb-btn sb-btn-icon w-100-p text-center m-t-10">
              {getTranslationKey('shop.forms.viewGallery')}
            </Button>
          </>
        )}

        <div className="mt-4">
          {isWrongPassword && <Alert color="danger">{getTranslationKey('passwordWrong')}</Alert>}

          {lockedUntil && <Alert color="danger">{lockedUntilText}</Alert>}
        </div>
      </PasswordForm>
    </Form>
  );
};
